export class EnableResourceOverrideLimitsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "updatedResource",
            "baseName": "updatedResource",
            "type": "InventoryResource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableResourceOverrideLimitsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
